import { CompanyValues } from '@features/invoicingSettings/types/companyValues'
import { getPrimaryTradeName } from '@features/invoicingSettings/utils/getPrimaryTradeName'
import { getTradeNamesWithUpdatedPrimaryContact } from '@features/invoicingSettings/utils/getTradeNamesWithUpdatedPrimaryContact'

import { InvoiceSettingsForm } from '../../types/invoiceSettingsForm'

export const getCompanyPayload = (company: CompanyValues, formData: InvoiceSettingsForm): CompanyValues => {
  const {
    logoId,
    contactEmail,
    contactFirstName,
    contactLastName,
    contactPhone,
    logoUrl,
    vatRatePercent,
    vatRateId,
    legalFormSettings,
    legalMentions,
  } = formData

  const tradeNamesWithContact = getTradeNamesWithUpdatedPrimaryContact(company.tradeNames, {
    contactEmail,
    contactFirstName,
    contactLastName,
    contactPhone,
  })
  const primaryTradeName = getPrimaryTradeName(tradeNamesWithContact)

  const tradeNames = tradeNamesWithContact.map((tradeName) => {
    if (tradeName !== primaryTradeName) {
      return tradeName
    }

    const { logo, ...rest } = tradeName

    return {
      ...rest,
      // Include logo only if logoId is set;
      // logoId is a null after delete action
      ...(logoId
        ? {
            logo: {
              id: logoId,
              content: logoUrl ?? undefined,
            },
          }
        : {}),
    }
  })

  return {
    ...company,
    legalFormSettings,
    legalMentions,
    tradeNames,
    vatRateId,
    vat: vatRatePercent,
  }
}
